import React from 'react';

const ServerErrorPage: React.FC = () => {
  return (
      <div className="screen-cover flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center w-[80%] mx-4 space-y-4">
              <img src={`/avatea_500_nobg.png`} alt="500 Server Error" className="h-[50%]" />
              <h1 className="text-xl font-semibold text-eoe-text-heading dark:text-eoe-dark-text-heading">
                  All steeped out
              </h1>
              <p className="text-sm text-eoe-text-2 dark:text-eoe-dark-text-2">
                It's not you—it's probably us, but please try to reload the page or check back later.
              </p>
              <a href="/" className="w-full">
                  <span className="btn-primary block w-full my-2 text-center">
                      Try Reloading
                  </span>
              </a>
          </div>
      </div>
  );
};

export default ServerErrorPage;